/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService
 */
import * as References from './SensitiveDataStatusControllerFrontendService';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService#enableSensitiveDataAsync
 */
export const ENABLE_SENSITIVE_DATA_ASYNC_MUTATION_FIELD_NAME =
  'com_hubspot_sensitive_data_status_controller_rpc_SensitiveDataStatusControllerFrontendService_enableSensitiveDataAsync';
export const ENABLE_SENSITIVE_DATA_ASYNC_MUTATION: RegisteredQuery<
  'result',
  References.EnableSensitiveDataAsyncRequestType,
  References.EnableSensitiveDataAsyncResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: ENABLE_SENSITIVE_DATA_ASYNC_MUTATION_FIELD_NAME,
  args: ['sensitiveDataResponses'],
  fetcher(
    request: References.EnableSensitiveDataAsyncRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.EnableSensitiveDataAsyncResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.enableSensitiveDataAsyncRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService#disableSensitiveDataAsync
 */
export const DISABLE_SENSITIVE_DATA_ASYNC_MUTATION_FIELD_NAME =
  'com_hubspot_sensitive_data_status_controller_rpc_SensitiveDataStatusControllerFrontendService_disableSensitiveDataAsync';
export const DISABLE_SENSITIVE_DATA_ASYNC_MUTATION: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.DisableSensitiveDataAsyncResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: DISABLE_SENSITIVE_DATA_ASYNC_MUTATION_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.DisableSensitiveDataAsyncResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.disableSensitiveDataAsyncRpc,
      { timeout: ctx.timeout }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService#getSensitiveDataOnboardingOrEnabled
 */
export const GET_SENSITIVE_DATA_ONBOARDING_OR_ENABLED_QUERY_FIELD_NAME =
  'com_hubspot_sensitive_data_status_controller_rpc_SensitiveDataStatusControllerFrontendService_getSensitiveDataOnboardingOrEnabled';
export const GET_SENSITIVE_DATA_ONBOARDING_OR_ENABLED_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.GetSensitiveDataOnboardingOrEnabledResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_SENSITIVE_DATA_ONBOARDING_OR_ENABLED_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetSensitiveDataOnboardingOrEnabledResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getSensitiveDataOnboardingOrEnabledRpc,
      { timeout: ctx.timeout }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService#getSensitiveDataSubsettings
 */
export const GET_SENSITIVE_DATA_SUBSETTINGS_QUERY_FIELD_NAME =
  'com_hubspot_sensitive_data_status_controller_rpc_SensitiveDataStatusControllerFrontendService_getSensitiveDataSubsettings';
export const GET_SENSITIVE_DATA_SUBSETTINGS_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.GetSensitiveDataSubsettingsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_SENSITIVE_DATA_SUBSETTINGS_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetSensitiveDataSubsettingsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getSensitiveDataSubsettingsRpc,
      { timeout: ctx.timeout }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService#getHipaaEnabledForPortal
 */
export const GET_HIPAA_ENABLED_FOR_PORTAL_QUERY_FIELD_NAME =
  'com_hubspot_sensitive_data_status_controller_rpc_SensitiveDataStatusControllerFrontendService_getHipaaEnabledForPortal';
export const GET_HIPAA_ENABLED_FOR_PORTAL_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.GetHipaaEnabledForPortalResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_HIPAA_ENABLED_FOR_PORTAL_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetHipaaEnabledForPortalResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getHipaaEnabledForPortalRpc,
      { timeout: ctx.timeout }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService#updateSubsettingsAsync
 */
export const UPDATE_SUBSETTINGS_ASYNC_MUTATION_FIELD_NAME =
  'com_hubspot_sensitive_data_status_controller_rpc_SensitiveDataStatusControllerFrontendService_updateSubsettingsAsync';
export const UPDATE_SUBSETTINGS_ASYNC_MUTATION: RegisteredQuery<
  'result',
  References.UpdateSubsettingsAsyncRequestType,
  References.UpdateSubsettingsAsyncResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: UPDATE_SUBSETTINGS_ASYNC_MUTATION_FIELD_NAME,
  args: ['subsettingsToUpdate'],
  fetcher(
    request: References.UpdateSubsettingsAsyncRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.UpdateSubsettingsAsyncResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.updateSubsettingsAsyncRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService#getSensitiveDataStateAndSubsettingsForPortal
 */
export const GET_SENSITIVE_DATA_STATE_AND_SUBSETTINGS_FOR_PORTAL_QUERY_FIELD_NAME =
  'com_hubspot_sensitive_data_status_controller_rpc_SensitiveDataStatusControllerFrontendService_getSensitiveDataStateAndSubsettingsForPortal';
export const GET_SENSITIVE_DATA_STATE_AND_SUBSETTINGS_FOR_PORTAL_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.GetSensitiveDataStateAndSubsettingsForPortalResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName:
    GET_SENSITIVE_DATA_STATE_AND_SUBSETTINGS_FOR_PORTAL_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetSensitiveDataStateAndSubsettingsForPortalResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getSensitiveDataStateAndSubsettingsForPortalRpc,
      { timeout: ctx.timeout }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService#getSensitiveDataStateForPortal
 */
export const GET_SENSITIVE_DATA_STATE_FOR_PORTAL_QUERY_FIELD_NAME =
  'com_hubspot_sensitive_data_status_controller_rpc_SensitiveDataStatusControllerFrontendService_getSensitiveDataStateForPortal';
export const GET_SENSITIVE_DATA_STATE_FOR_PORTAL_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.GetSensitiveDataStateForPortalResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_SENSITIVE_DATA_STATE_FOR_PORTAL_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetSensitiveDataStateForPortalResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getSensitiveDataStateForPortalRpc,
      { timeout: ctx.timeout }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService#getPortalDisablementPermitted
 */
export const GET_PORTAL_DISABLEMENT_PERMITTED_QUERY_FIELD_NAME =
  'com_hubspot_sensitive_data_status_controller_rpc_SensitiveDataStatusControllerFrontendService_getPortalDisablementPermitted';
export const GET_PORTAL_DISABLEMENT_PERMITTED_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.GetPortalDisablementPermittedResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_PORTAL_DISABLEMENT_PERMITTED_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetPortalDisablementPermittedResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getPortalDisablementPermittedRpc,
      { timeout: ctx.timeout }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService#getPortalEligibilityForSensitiveData
 */
export const GET_PORTAL_ELIGIBILITY_FOR_SENSITIVE_DATA_QUERY_FIELD_NAME =
  'com_hubspot_sensitive_data_status_controller_rpc_SensitiveDataStatusControllerFrontendService_getPortalEligibilityForSensitiveData';
export const GET_PORTAL_ELIGIBILITY_FOR_SENSITIVE_DATA_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.GetPortalEligibilityForSensitiveDataResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_PORTAL_ELIGIBILITY_FOR_SENSITIVE_DATA_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetPortalEligibilityForSensitiveDataResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getPortalEligibilityForSensitiveDataRpc,
      { timeout: ctx.timeout }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService#getMaskingOptIn
 */
export const GET_MASKING_OPT_IN_QUERY_FIELD_NAME =
  'com_hubspot_sensitive_data_status_controller_rpc_SensitiveDataStatusControllerFrontendService_getMaskingOptIn';
export const GET_MASKING_OPT_IN_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.GetMaskingOptInResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_MASKING_OPT_IN_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetMaskingOptInResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getMaskingOptInRpc,
      { timeout: ctx.timeout }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService#setMaskingOptIn
 */
export const SET_MASKING_OPT_IN_MUTATION_FIELD_NAME =
  'com_hubspot_sensitive_data_status_controller_rpc_SensitiveDataStatusControllerFrontendService_setMaskingOptIn';
export const SET_MASKING_OPT_IN_MUTATION: RegisteredQuery<
  'result',
  References.SetMaskingOptInRequestType,
  References.SetMaskingOptInResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: SET_MASKING_OPT_IN_MUTATION_FIELD_NAME,
  args: ['optedIn'],
  fetcher(
    request: References.SetMaskingOptInRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.SetMaskingOptInResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.setMaskingOptInRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService#getBreezeAccessOptIns
 */
export const GET_BREEZE_ACCESS_OPT_INS_QUERY_FIELD_NAME =
  'com_hubspot_sensitive_data_status_controller_rpc_SensitiveDataStatusControllerFrontendService_getBreezeAccessOptIns';
export const GET_BREEZE_ACCESS_OPT_INS_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.GetBreezeAccessOptInsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_BREEZE_ACCESS_OPT_INS_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetBreezeAccessOptInsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getBreezeAccessOptInsRpc,
      { timeout: ctx.timeout }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService#setBreezeAccessOptIn
 */
export const SET_BREEZE_ACCESS_OPT_IN_MUTATION_FIELD_NAME =
  'com_hubspot_sensitive_data_status_controller_rpc_SensitiveDataStatusControllerFrontendService_setBreezeAccessOptIn';
export const SET_BREEZE_ACCESS_OPT_IN_MUTATION: RegisteredQuery<
  'result',
  References.SetBreezeAccessOptInRequestType,
  References.SetBreezeAccessOptInResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: SET_BREEZE_ACCESS_OPT_IN_MUTATION_FIELD_NAME,
  args: ['optedIn', 'optInType'],
  fetcher(
    request: References.SetBreezeAccessOptInRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.SetBreezeAccessOptInResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.setBreezeAccessOptInRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
